import {
  AlphaSize,
  Category,
  Color,
  Material,
  SizeType,
  SubCategory,
  SubTechnique,
  Type,
} from '@buf/upcyclers_gateway.bufbuild_es/product/v2/product_pb';

import {
  mapProductEnumOptions,
  mapProductEnumToString,
  mapProductFilterOptions,
  PRODUCT_PROPERTIES,
} from './mappings';

// ========== Enum Mappings ==========
export const mapProductTypeToString = (value?: Type) =>
  mapProductEnumToString(PRODUCT_PROPERTIES.Types, value ?? Type.UNSPECIFIED);

export const mapProductCategoryToString = (value?: Category) =>
  mapProductEnumToString(
    PRODUCT_PROPERTIES.Category,
    value ?? Category.UNSPECIFIED,
  );

export const mapProductSubCategoryToString = (value?: SubCategory) =>
  mapProductEnumToString(
    PRODUCT_PROPERTIES.SubCategory,
    value ?? SubCategory.UNSPECIFIED,
  );

export const mapProductAlphaSizeToString = (value?: AlphaSize) =>
  mapProductEnumToString(
    PRODUCT_PROPERTIES.AlphaSize,
    value ?? AlphaSize.UNSPECIFIED,
  );

export const mapProductMaterialsToString = (value?: Material[]) =>
  (value ?? [Material.UNSPECIFIED])
    .map((material) =>
      mapProductEnumToString(
        PRODUCT_PROPERTIES.Materials,
        material ?? Material.UNSPECIFIED,
      ),
    )
    .filter((material) => material !== 'N/A')
    .join(', ') || 'N/A';

export const mapProductSizeTypeToString = (value?: SizeType) =>
  mapProductEnumToString(
    PRODUCT_PROPERTIES.SizeType,
    value ?? SizeType.UNSPECIFIED,
  );

export const mapProductColorToString = (value?: Color) =>
  mapProductEnumToString(PRODUCT_PROPERTIES.Color, value ?? Color.UNSPECIFIED);

export const mapProductSubTechniquesToString = (value?: SubTechnique[]) =>
  (value ?? [SubTechnique.UNSPECIFIED]).map((subTechnique) =>
    mapProductEnumToString(PRODUCT_PROPERTIES.SubTechnique, subTechnique),
  );

// ========== Enum Options ==========
export const mapProductSizeTypeOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.SizeType,
);
export const mapProductAlphaSizeOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.AlphaSize,
);
export const mapProductShoeWidthOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.ShoeWidth,
);
export const mapProductDecadeOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.Decade,
);
export const mapProductPatternOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.Pattern,
);
export const mapProductSizeCategoryOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.SizeCategory,
);
export const mapProductCategoryOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.Category,
);
export const mapProductSubCategoryOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.SubCategory,
).filter(
  (s) =>
    s.value != SubCategory.OTHER && s.value != SubCategory.JUMPSUIT_AND_ROMPERS,
);
export const mapProductConditionOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.Condition,
);
export const mapProductTypesOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.Types,
);
export const mapProductIdentifierOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.Identifiers,
  ['other'],
);
export const mapProductColorOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.Color,
  ['multi', 'other'],
);
export const mapProductMaterialOptions = mapProductEnumOptions(
  PRODUCT_PROPERTIES.Materials,
  ['other'],
);

// ========== Enum Filters ==========
export const mapProductTypeFilters = mapProductFilterOptions(
  PRODUCT_PROPERTIES.Types,
);

export const mapProductIdentifierFilters = mapProductFilterOptions(
  PRODUCT_PROPERTIES.Identifiers,
);

export const mapProductCategoryFilters = mapProductFilterOptions(
  PRODUCT_PROPERTIES.Category,
);

export const mapProductPriceFilters = mapProductFilterOptions(
  PRODUCT_PROPERTIES.Price,
);

export const mapProductColorFilters = mapProductFilterOptions(
  PRODUCT_PROPERTIES.PrimaryColors,
  ['multi', 'other'],
);

export const mapProductMaterialFilters = mapProductFilterOptions(
  PRODUCT_PROPERTIES.Materials,
  ['other'],
);

export const mapProductTechniqueFilters = mapProductFilterOptions(
  PRODUCT_PROPERTIES.Technique,
);

export const mapProductSubTechniqueFilters = mapProductFilterOptions(
  PRODUCT_PROPERTIES.SubTechnique,
);
